module.exports = __webpack_public_path__ + "img/actions.95d101a9.svg";